import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import "swiper/css";
import "swiper/css/navigation";

const HomeCarousel = () => {
  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Custom Arrows */}
      <div className="custom-prev">
        <FaChevronLeft size={28} />
      </div>

      <div className="custom-next">
        <FaChevronRight size={28} />
      </div>

      <Swiper
        modules={[Autoplay, Navigation]}
        navigation={{
          prevEl: ".custom-prev",
          nextEl: ".custom-next",
        }}
        slidesPerView={3}
        slidesPerGroup={1}
        spaceBetween={0}
        loop={true}
        speed={1200}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        <SwiperSlide>
          <img src="/img/carousel-1.jpg" style={imgStyle} />
        </SwiperSlide>

        <SwiperSlide>
          <img src="/img/carousel-2.jpg" style={imgStyle} />
        </SwiperSlide>

        <SwiperSlide>
          <img src="/img/carousel-3.jpg" style={imgStyle} />
        </SwiperSlide>

        <SwiperSlide>
          <img src="/img/carousel-4.jpg" style={imgStyle} />
        </SwiperSlide>

        <SwiperSlide>
          <img src="/img/carousel-5.jpg" style={imgStyle} />
        </SwiperSlide>
      </Swiper>

      <style>{`
        .custom-prev,
        .custom-next {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 20;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(0,0,0,0.5);
          color: #DFB163;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: 0.3s;
        }

        .custom-prev {
          left: 15px;
        }

        .custom-next {
          right: 15px;
        }

        .custom-prev:hover,
        .custom-next:hover {
          background: rgba(0,0,0,0.8);
        }

        /* Hide Default Swiper Arrows */
        .swiper-button-prev,
        .swiper-button-next {
          display: none !important;
        }
      `}</style>
    </div>
  );
};

const imgStyle = {
  width: "100%",
  height: "400px",
  objectFit: "cover",
  display: "block",
};

export default HomeCarousel;